import { module } from "angular";
import { CardComponent } from "./CardComponent";

module("mmGui").component("mmCard", new CardComponent());
